import { gql } from "@apollo/client";

// Goes through the generate_enforcement_photo_upload_url Hasura Action (AUT-5916) rather than
// calling the API's POST /v1/enforcement_intents/photo-upload-url directly, so the browser only
// ever talks to Hasura -- the API has no CORS handling and its URL stays out of the bundle. The
// action only returns what uploadEvidencePhoto actually uses: the upload record's id (submitted
// back as licensePlateImageId/violationImageId) and the presigned S3 PUT URL.
export const GENERATE_ENFORCEMENT_PHOTO_UPLOAD_URL = gql`
  mutation GenerateEnforcementPhotoUploadUrl($contentType: String!, $fileName: String) {
    generateEnforcementPhotoUploadUrl: generate_enforcement_photo_upload_url(
      content_type: $contentType
      file_name: $fileName
    ) {
      id
      presignedUrl: presigned_url
    }
  }
`;

export interface GenerateEnforcementPhotoUploadUrlData {
  generateEnforcementPhotoUploadUrl: {
    id: string;
    presignedUrl: string;
  } | null;
}

export interface GenerateEnforcementPhotoUploadUrlVars {
  contentType: string;
  fileName?: string;
}

export default GENERATE_ENFORCEMENT_PHOTO_UPLOAD_URL;
